export default "__VITE_ASSET__CdNXM8ii__"